import { SVGProps, memo } from 'react';
const DeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "24"} height={props.height || "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 2186">
      <g id="Group 1429">
        <path id="Vector 469" d="M4.79272 4.79153V20.7367C4.79272 21.1708 5.14307 21.5234 5.57708 21.5262L17.4294 21.6031C17.8674 21.6059 18.224 21.2516 18.224 20.8136V4.87866M4.79272 4.79153H3.00024L14.1877 4.87866M4.79272 4.79153L8.81926 4.87866M18.224 4.87866H20.0001H14.1877M18.224 4.87866H14.1877M8.81926 4.87866V2.6264C8.81926 2.19038 9.17272 1.83691 9.60874 1.83691L13.3982 1.83691C13.8342 1.83691 14.1877 2.19038 14.1877 2.6264V4.87866M8.81926 4.87866H14.1877" stroke={props.stroke || "#D32F2F"} strokeWidth={props.strokeWidth || "1.8"} strokeLinejoin="round"/>
        <path id="Vector 470" d="M8.8584 10.1621V16.4057" stroke={props.stroke || "#D32F2F"} strokeWidth={props.strokeWidth || "1.8"} strokeLinecap="round"/>
        <path id="Vector 471" d="M14.0618 10.1621V16.4057" stroke={props.stroke || "#D32F2F"} strokeWidth={props.strokeWidth || "1.8"} strokeLinecap="round"/>
      </g>
    </g>
  </svg>
);

export default memo(DeleteIcon);
